$(document).ready(function() {

	$('.strategy--circle').on('click',function(e) {

		e.preventDefault();
		$('.strategy--circle').removeClass('is-active');
		$(this).addClass('is-active');
		var href = $(this).attr('href');

		$('.strategy--content').removeClass('is-active');
		$(href).addClass('is-active');

		anime({
		  targets: '.strategy--circle',
		  translateX: 250,
		  scale: 2,
		  rotate: '1turn'
		});

	});

});
